module.exports = __webpack_public_path__ + "static/media/tunnel1.6b1e26c2.png";